import React, { useState, useEffect, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Login from "../views/authentication/Login";
import Layout from "../views/layout/Layout";
import PeopleLikeMe from "../views/Posts/PeopleLikeMe";
import Post from "../views/Posts/Post";
import EmailVerify from "../views/authentication/EmailVerify";
import ForgotPswd from "../views/authentication/ForgotPswd";
import ResetPassword from "../views/authentication/ResetPassword";
import SendPopup from "../views/authentication/SendPopup";
import ResetPopUp from "../views/authentication/ResetPopUp";
import ProfilePage from "../views/Profile/Profilepage";
import Discussions from "../views/Organization/Discussions";
import Organization from "../views/Organization/Profile";
import EditProfile from "../views/Profile/EditProfile";
import EditOrganization from "../views/Organization/EditOrganization";
import JoinCommunity from "../views/JoinCommunity/joinCommunity";
import UpcomingEvent from "../views/UpcomingEvents/UpcomingEvent";
import CreateEvent from "../views/UpcomingEvents/CreateEvent";
import ViewEventDetails from "../views/UpcomingEvents/ViewEventDetais";
import DreamersPodcast from "../views/Podcast/DreamersPodcat";
import ContactUs from "../views/OtherLinks/Contact";
import Faq from "../views/OtherLinks/Faq";
import TopCommunities from "../views/FollowOrganization/TopCommunities";
import TopOrganizations from "../views/FollowOrganization/TopOrganizations";
import Messages from "../views/Messages/Message";
import IndividualProfile from "../views/Profile/IndividualProfile";
import PrivacyPolicy from "../views/OtherLinks/PrivacyPolicy";
import Advertisement from "../views/OtherLinks/Advertisement";
import TermsConditions from "../views/OtherLinks/TermsCondition";
import OrganizationUserView from "../views/Organization/OrganizationUserView";
import OrganizationProfile from "../views/Organization/OrganizationProfile";
import SinglePost from "../views/Posts/SinglePost";
import SearchPosts from "../views/Posts/SearchPosts";
import CommonPrivacy from "../views/OtherLinks/CommonPrivacy";

const Routing = () => {
  return (
    <Routes>

      <Route path="/" element={<Login />} />
      <Route path="/:token" element={<Login />} />
      <Route path="/privacy" element={<CommonPrivacy />} />
      <Route path="/forgot-password" element={<ForgotPswd />} />
      <Route path="/forgot-password/verify" element={<SendPopup />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/password-reset" element={<ResetPopUp />} />
      <Route path="/email-verification/:token" element={<EmailVerify />} />
      <Route path="/" element={<Layout />} >  {/* common layout for all pages */}
        <Route path="justlikeme" element={<PeopleLikeMe />} />{/*  inner page after login  */}

        {/* Rest of the routes  */}
        <Route path="feed/:communityNameSlug" element={<Post />} />
        <Route path="post" element={<SinglePost />} />
         <Route path="SearchPost" element={<SearchPosts />} />
        <Route path="joinacommunity" element={<JoinCommunity />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="profile/:userName" element={<IndividualProfile />} />
         <Route path="discussions" element={<Discussions />} />
        <Route path="organization" element={<Organization />} />
         <Route path="organization/:userName" element={<OrganizationProfile />} />
        <Route path="edit-profile" element={<EditProfile />} />
        <Route path="edit-organization" element={<EditOrganization />} />
        <Route path="organization/view/:slug" element={<OrganizationUserView />} />
        
        <Route path="event/:communitySlug" element={<UpcomingEvent/>} />
        <Route path="event/create-event" element={<CreateEvent />} />
        <Route path="event-details" element={<ViewEventDetails />} />  

        <Route path="followanorganization" element={<TopCommunities />} />
        <Route path="top-organizations" element={<TopOrganizations />} />
        <Route path="media" element={<DreamersPodcast />} />
        <Route path="contact-us" element={<ContactUs />} />
        <Route path="faq" element={<Faq />} />
       <Route path="advertisement-policy" element={<Advertisement />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-and-condition" element={<TermsConditions />} />
       
        <Route path="message" element={<Messages />} />
        
      </Route>


    </Routes>
  )
}
export default Routing